import $ from "jquery";
import { each } from "lodash";
import { x, isDesktop } from "../../_helpers";
import { initHeroCarousel } from "../../_helpers/swiper-helper";

export default class HeroCarousel {
  constructor() {
    this.carousels = x("[js-carousel-hero-headline]");

    if (this.carousels) {
      this.init();
    }
  }

  init() {
    if (isDesktop()) return null;

    // Initialize each hero carousel
    each(this.carousels, (el) => {
      // update classes
      $(el)
        .parent()
        .addClass(
          "fo-carousel fo-carousel--height-modifier-event oc-c-events-carousel",
        );
      $(el)
        .children(".oc-c-hero-headlines__top-stories--inner")
        .addClass("swiper-wrapper");

      // initialize hero carousel
      initHeroCarousel(el);
    });
  }
}
